import { SET_BULK_PARAMS_USER, CLEAR_PARAMS_USER, SET_PARAMS_USER } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    role_id: "",
    sort: "asc",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_USER:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_PARAMS_USER:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_USER:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
